// Frontend feature flags derived from environment variables.
// Used to toggle UI for experimental or add-on features.

export const FEATURE_WATERMARK_REMOVAL =
	(process.env.REACT_APP_FEATURE_WATERMARK_REMOVAL || '').toLowerCase() === 'true';

const features = {
	FEATURE_WATERMARK_REMOVAL
};

export default features;

